<div class="trucking-component">
  <div class="heading flex flex-row justify-between">
    <h2 class="text-white">Trucking Contracts</h2>
    <div class="self-center">
      <button class="h-auto" mat-flat-button color="primary" (click)="createNew$$.next({})">ADD NEW</button>
    </div>
  </div>

  <mat-tab-group class="h-full">
    <mat-tab label="Active">
      <ng-container *ngIf="networkActive$ | async; else activeContractTable">
        <mat-spinner [diameter]="100"></mat-spinner>
      </ng-container>
      <ng-template #activeContractTable>
        <div class="flex flex-row items-center pt-1">
          <i class="searchImage px-1 material-icons">search</i>
          <mat-form-field class="search w-full pr-2">
            <input matInput placeholder="Search" [formControl]="activeContractSearch" autocomplete="off" autofocus />
          </mat-form-field>
        </div>
        <sa-trucking-list-table [contracts]="activeContracts$"></sa-trucking-list-table>
      </ng-template>
    </mat-tab>
    <mat-tab label="Archived">
      <ng-container *ngIf="networkActive$ | async; else archivedContractTable">
        <mat-spinner [diameter]="100"></mat-spinner>
      </ng-container>
      <ng-template #archivedContractTable>
        <div class="flex flex-row items-center pt-1">
          <i class="searchImage px-1 material-icons">search</i>
          <mat-form-field class="search w-full pr-2">
            <input matInput placeholder="Search" [formControl]="archivedContractSearch" autocomplete="off" autofocus />
          </mat-form-field>
        </div>
        <sa-trucking-list-table [contracts]="archivedContracts$"></sa-trucking-list-table>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>

<ng-container *ngIf="selectedContract$ | async as selectedContract">
  <div class="back-layer-component" [@fadeInOut] (click)="closeVendorForm($event)"></div>
  <sa-vendor-contract-edit
    [allVendors]="allVendors$ | async"
    [selectedRow]="selectedContract"
    (onCloseClicked)="closeVendorForm($event)"
  >
  </sa-vendor-contract-edit>
</ng-container>

<ng-container *ngIf="createNew$$ | async as openCreate">
  <div class="back-layer-component" [@fadeInOut] (click)="closeNewContractForm($event)"></div>
  <sa-vendor-contract-creation [clone]="openCreate" (onCloseClicked)="closeNewContractForm($event)">
  </sa-vendor-contract-creation>
</ng-container>
